// lib/utils.ts
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

// Simple country utilities without external dependencies
export const getCountryName = (code: string): string => {
    if (!code) return "Unknown";

    const countryMap: Record<string, string> = {
        'US': 'United States',
        'GB': 'United Kingdom',
        'CA': 'Canada',
        'AU': 'Australia',
        'DE': 'Germany',
        'FR': 'France',
        'JP': 'Japan',
        'BR': 'Brazil',
        'IN': 'India',
        'CN': 'China',
        'RU': 'Russia',
        'IT': 'Italy',
        'ES': 'Spain',
        'NL': 'Netherlands',
        'SE': 'Sweden',
        'NO': 'Norway',
        'DK': 'Denmark',
        'FI': 'Finland',
    };

    return countryMap[code.toUpperCase()] || code;
}

export const getCountryFlagUrl = (code: string): string => {
    const countryCode = String(code || "US").toLowerCase();
    return `https://flagcdn.com/w20/${countryCode}.png`;
}